// src/pages/BundeslandBadenWuerttemberg.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { badenWuerttemberg } from "../components/states/baden-wuerttemberg";

export default function BundeslandBadenWuerttemberg() {
  return <BundeslandPage data={badenWuerttemberg} />;
}

